<ul class="navbar-nav mr-auto">
  <li class="nav-item">
  </li>
</ul>
